import React from 'react'

import { ButtonColor } from '../../../ui-lib/button'
import { SignUpProductRecButton } from '../../../item/cta-button/signup-product-recommendation'
import { OutputDetectedShape, OutputTitle, OutputAiDetected } from '../output-components'

import styles from './ai-detector-desktop.module.scss'

interface AIDetectorDesktopOutputProps {
  aiPercent: number | null
}

export const AIDetectorDesktopOutput: React.FC<AIDetectorDesktopOutputProps> = (props) => {
  const { aiPercent } = props
  const hasAiPercent = aiPercent !== null

  return (
    <div className={styles.outputContainer}>
      <div className={styles.outputAIContent}>
        <OutputDetectedShape />
        <OutputTitle aiPercent={aiPercent} />
      </div>
      <OutputAiDetected aiPercent={aiPercent} />
      <div className={styles.outputButtonContainer}>
        <SignUpProductRecButton
          compact
          color={ButtonColor.WDK24SecondaryLightBg}
          text={
            hasAiPercent && aiPercent > 0 ? (
              <span>
                <b>Get Grammarly</b>
              </span>
            ) : (
              <span>
                <b>Get Grammarly</b> It&apos;s Free
              </span>
            )
          }
          showArrow
        />
      </div>
    </div>
  )
}
